import '@ungap/custom-elements';
import * as bootstrap from 'bootstrap';
(window as any).bootstrap = bootstrap;
import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

import { CentersExplorator } from './js/components/CentersExplorator';
customElements.define('centers-explorator', CentersExplorator, { extends: 'div' });

import { CollapseLongContent } from './js/components/CollapseLongContent';
customElements.define('collapse-long-content', CollapseLongContent, { extends: 'div' });

import { SearchFilters } from './js/components/SearchFilters';
customElements.define('search-filters', SearchFilters, { extends: 'div' });

import { FilterTree } from './js/components/FilterTree';
customElements.define('filter-tree', FilterTree, { extends: 'div' });

import { SearchForm } from './js/components/SearchForm';
customElements.define('search-form', SearchForm, { extends: 'form' });

import { FormationSearch } from './js/components/FormationSearch';
customElements.define('formation-search', FormationSearch, { extends: 'form' });

import { SiteHeader } from './js/components/SiteHeader';
customElements.define('site-header', SiteHeader, { extends: 'header' });

import { SessionFilter } from './js/components/SessionFilter';
customElements.define('session-filter', SessionFilter, { extends: 'div' });

import { ModalInscription } from './js/components/ModalInscription';
customElements.define('modal-inscription', ModalInscription, { extends: 'div' });

import { DocumentationDownload } from './js/components/DocumentationDownload';
customElements.define('documentation-download', DocumentationDownload, { extends: 'div' });

import { SplideCollapseRefresh } from './js/components/SplideCollapseRefresh';
customElements.define('splide-collapse-refresh', SplideCollapseRefresh, { extends: 'div' });

// Initialiser Splide sur les éléments avec la classe splide

document.addEventListener('DOMContentLoaded', () => {
  const splideElements = document.querySelectorAll('.splide');
  splideElements.forEach(element => {
    new Splide(element as HTMLElement).mount({ Grid });
  });
});

import './scss/main.scss';